import { redirect } from 'redux-first-router'
import * as R from 'ramda'
import { t } from 'ttag'

import { toModel } from 'ducks/router'
import { modelActions } from './actions'
import { useItem, useModel } from './hooks'
import { getOrm, modelSelectors } from './selectors'

const translate = (endpoint, plural) =>
  R.pathOr('??', [endpoint, plural ? 1 : 0], {
    projects: [t`job`, t`jobs`],
    candidates: [t`candidate`, t`candidates`],
    templates: [t`template`, t`templates`],
    documents: [t`document`, t`documents`],
    departments: [t`department`, t`departments`],
    users: [t`user`, t`users`],
  })

const orm = R.when(R.is(String), endpoint => ({
  ...modelActions(endpoint),
  ...modelSelectors(endpoint),
  // TODO: have to consider to adjust model, so that we do not need to pass undefined, undefined
  toList: () => toModel(endpoint, undefined, undefined),
  toCreate: (tab = 1) => toModel(endpoint, 'add', tab),
  toDetail: (pk, tab = 1, query, replace = false) => {
    const action = toModel(endpoint, pk, tab, query)
    return replace ? redirect(action) : action
  },
  useModel: params => useModel(endpoint, params),
  useItem: pk => useItem(endpoint, pk),
  pluralize: n => translate(endpoint, n !== 1),
  toString: () => translate(endpoint, true),
  endpoint,
}))

export default orm
export { getOrm, useModel, useItem }

export const accounts = orm('accounts')
export const candidates = orm('candidates')
export const documents = orm('documents')
export const interviewTemplates = orm('interviewtemplates')
export const jobs = orm('projects')
export const jobTemplates = orm('projecttemplates')
export const questions = orm('interview/questions')
export const skills = orm('projectskills')
export const templates = orm('templates')
export const overviewCareer = orm('careeroverview')
export const invitesCareer = orm('careerinvites')
export const resultsCareer = orm('resultscareer')
export const departments = orm('departments')
export const users = orm('users')
